/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdSlidesSlideid202,
  DeleteApiV1ClassroomdisciplineIdSlidesSlideid401,
  DeleteApiV1ClassroomdisciplineIdSlidesSlideid404,
  DeleteApiV1ClassroomdisciplineIdSlidesSlideidMutationResponse,
  DeleteApiV1ClassroomdisciplineIdSlidesSlideidPathParams,
} from "../../types/classPlanningMaterialController/DeleteApiV1ClassroomdisciplineIdSlidesSlideid.ts";

export const deleteApiV1ClassroomdisciplineIdSlidesSlideidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    slideId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdSlidesSlideidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdSlidesSlideid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdSlidesSlideid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdSlidesSlideid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdSlidesSlideid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdSlidesSlideid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdSlidesSlideid404>;

export const deleteApiV1ClassroomdisciplineIdSlidesSlideidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdSlidesSlideid202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdSlidesSlideidMutationResponse>;
